import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { last } from 'lodash'
import { AlmanacFileBreadcrumbs, AlmanacFileTitle } from 'common/Breadcrumbs/AlmanacFileBreadcrumbs'
import { useRootStore } from 'stores/RootStore'
import Styles from './FilenameAndBreadcrumb.module.scss'
import { Heading, HeadingLevel } from 'blaze-ui/Heading/Heading'

interface Props {
  id: string
  variant?: 'compact' | 'fullsize' | 'pageName'
  size?: 'lg' | 'xl' | 'xxl'
}

export const FilenameAndBreadcrumb = observer(({ id, variant = 'fullsize', size = 'xxl' }: Props) => {
  const rootStore = useRootStore()
  const file = rootStore.files.get(id)
  const parent = last(file?.ancestors)

  if (!file) return null

  return (
    <div className={cx(Styles.container, Styles[variant])}>
      <div
        className={cx(Styles.breadcrumbs, {
          [Styles.visible]: variant === 'fullsize' && parent,
        })}
      >
        <AlmanacFileBreadcrumbs
          file={file}
          ancestors={file.ancestors}
          assetType="Project"
          showAllFiles
          weight="light"
        />
      </div>
      <div className={Styles.emojiAndFilename}>
        <AlmanacFileTitle id={file.id} assetType="Project" size={size}>
          <FileTitle
            title={file.title}
            headingLevel={
              {
                fullsize: 1,
                compact: 2,
                pageName: 5,
              }[variant] as HeadingLevel
            }
          />
        </AlmanacFileTitle>
      </div>
    </div>
  )
})

interface FileTitleProps {
  title?: string
  emoji?: string | null
  color?: string
  headingLevel?: HeadingLevel
}

export const FileTitle = ({ title, emoji, color, headingLevel = 1 }: FileTitleProps) => (
  <div className={Styles.emojiAndFilename}>
    {emoji && <div className={Styles.emojiContainer}>{emoji}</div>}
    <Heading level={headingLevel} color={color} lineClamp={1}>
      {title}
    </Heading>
  </div>
)
